import React, { useState } from 'react';
import {
    TextInput, SelectInput, Edit, Toolbar, Labeled, TextField,
    NumberInput, required, useTranslate, useRecordContext, usePermissions, useAuthProvider, SimpleForm
} from 'react-admin';
import clsx from 'clsx';
import GetTaskButton from './Buttons/GetTask';
import {
    CodStatoUsoChoices, Statuses, Statuses_1_Magazziniere, Statuses_2_Magazziniere,
    Statuses_3_Approvatore, ReverseChoices,
    Statuses_0_Magazziniere, Statuses_0_Approvatore, Statuses_0_Magazziniere_Guasto,
    Anomalie_Approvatore_To_DaEsaminare, Statuses_2_MagazziniereIB, Statuses_0_MagazziniereIB,
    Anomalie_Magazziniere, Anomalie_Magazziniere_Attr, CausaliChoices,
    Statuses_2_MagazziniereIB_OtherCodTerrSAP, Statuses_2_Magazziniere_OtherCodTerrSAP, Statuses_4_Approvatore,
    Anomalie_Approvatore_To_Scaricato, Causale_Addebito
} from '../objects';
import ValidateAndSaveButton from './Buttons/ValidateAndSave';
import UploadDocumentButton from './Buttons/UploadDocument';
import CustomDeleteButton from './Buttons/Delete';
import ResetButton from './Buttons/Reset';
import ValidateRegmanButton from './Buttons/ValidateRegman';
import FileListButton from '../devices/Buttons/FileListDialog';
import { useFormState, FormProvider, useForm } from 'react-hook-form';
import { Typography, Box, Card, Grid } from '@mui/material';
var authProvider = require('../../authProvider');

function DeviceEdit() {
    const [new_status, set_new_status] = useState('');
    const [new_anomalia, set_new_anomalia] = useState('');
    const [buttonClass, setButtonClass] = useState(clsx("noClass"));
    const translate = useTranslate();
    const permissions = usePermissions().permissions;
    const methods = useForm();
    const { isDirty } = useFormState(methods);
    const [orignalWR, setOriginalWR] = useState('');


    const [formValues, setFormValues] = useState({});

    const onChange = (caller) => {
        if (caller.target.name === 'status.codice') {
            set_new_status(caller.target.value);
        }
        else if (caller.target.name === 'anomalia.codice') {
            set_new_anomalia(caller.target.value);
        }
    };

    const DeviceTitle = () => {
        const record = useRecordContext();
        return <span>Apparato {record ? `${record.serial_number_tim}` : ''}</span>;
    };

    const DeviceToolbar = () => {
        const record = useRecordContext();
        let disable = true;
        let deletable = false;
        let upload = false;
        let resetable = false;
        let checkregman = false;

        if (record.status) {
            let originalStatus = record.status.codice;
            let newStatus = new_status;
            let originalAnomalia = record.anomalia ? record.anomalia.codice : undefined;
            let cod_terr_sap = record.cod_terr_sap;

            if (permissions === 'magazziniere') {
                //Only Magazziniere can delete  based on the status and anomalia, and also only if the SN is for his impresa
                if (originalStatus === '0' && originalAnomalia === '0') {
                    let impresa_cod_terr_sap = localStorage.getItem('impresa_cod_terr_sap');
                    impresa_cod_terr_sap = (!impresa_cod_terr_sap || impresa_cod_terr_sap === "") ? [] : JSON.parse(impresa_cod_terr_sap);

                    if (impresa_cod_terr_sap.includes(cod_terr_sap)) {
                        deletable = true;
                    }
                }

                //Only Magazziniere can upload a file for devices in Da Esaminare or Associato
                if (['0', '2', '7'].includes(originalStatus) || ['0', '2', '7'].includes(newStatus)) {
                    upload = true;
                }
            }

            //Only Approvattore can checkRegman for devices in Validato and  Status regman = 0
            if (permissions === "approvatore" && originalStatus === '3' && record.status_regman.codice === '0' && record.cod_terr_sap !== "IMCNS093") {
                let nonRegmanNMUs = localStorage.getItem('nonRegmanNMUs') ? localStorage.getItem('nonRegmanNMUs').split(',') : [];

                if (!nonRegmanNMUs.includes(record.cod_nmu.toString())) {
                    if (!record.status_collaudo_one || ['0', '2'].includes(record.status_collaudo_one.codice)) checkregman = true;
                }

                //TO_SM_201
                if (checkregman === true && record.flag_olo === "SI" && record.progetto_con_scarico !== null) checkregman = false;
            }

            if (permissions === 'magazziniere' && (['2', '7', '12'].includes(originalStatus) || (originalStatus === '0' && originalAnomalia !== '0'))) {
                if (originalAnomalia === '2' && record.codice_impresa_name !== authProvider.getData().data.company) {
                    resetable = false;
                }
                else {
                    resetable = true;
                }
            }

            if (!newStatus) {
                set_new_status(originalStatus);
            }

            //if (isDirty) {
                if (permissions === "magazziniere") {
                    if (['0', '1', '6'].includes(originalStatus) && ['0', '2', '7', '9'].includes(newStatus)) {
                        //CR_067 Magazziniere cannot update in this conditions 
                        if (originalAnomalia === '0' && record.codice_impresa_name !== authProvider.getData().data.company) {
                            disable = true;
                        }
                        else if (originalStatus === '0' && newStatus === '0') {
                            if (record.anomalia && ['0', '16'].includes(record.anomalia.codice)) {
                                disable = false;
                            }
                        }
                        else if (newStatus === '0' && !new_anomalia) {
                            disable = true;
                        }
                        else {
                            disable = false;
                        }
                    }
                    else if (['2', '7'].includes(originalStatus) && ['2', '3', '7'].includes(newStatus)) {
                        disable = false;
                    }
                    else if (['2', '7'].includes(originalStatus) && ['0'].includes(newStatus) && new_anomalia !== "") {
                        disable = false;
                    }
                }
                else if (permissions === "approvatore") {
                    if (originalStatus === '3' && ['0', '5'].includes(newStatus) && new_anomalia !== "") {
                        disable = false;
                    }
                    else if (originalStatus === '3' && ['4'].includes(newStatus)) {
                        disable = false;
                    }
                    else if (originalStatus === '4' && newStatus === '3') {
                        disable = false;
                    }
                }
            //}
        }
        return <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <ValidateAndSaveButton
                disabled={disable}
                label="Salva"
                redirect="list"
                submitOnEnter={false}
                variant="flat"
                rdata={record}
            />
            {checkregman ? <ValidateRegmanButton /> : undefined}
            {upload ? <UploadDocumentButton resource='devices' /> : undefined}
            {upload ? <FileListButton resource='devices' /> : undefined}
            {deletable ? <CustomDeleteButton
                undoable={false} /> : undefined}
            {resetable ? <ResetButton
                undoable={false} /> : undefined}
        </Toolbar>
    };

    const validateWorkrequestid = (value, allValues) => {
        if (allValues.status?.codice === '2' && !value) {
            return translate('tim.devices.get_task_mandatori');
        }
        else if (value) {
            //clear fields if the workrequestid changed manually
            var extRef = document.getElementById('workrequestid');
            if (extRef) {
                if (extRef.dataset.isSuccess === 'false') {
                    return translate('tim.devices.ivalid_gettask');
                }
                else if ((extRef.dataset.gettaskres && extRef.dataset.gettaskres !== extRef.value) || (!extRef.dataset.gettaskres && value != orignalWR)) {
                    console.log('clearing inputs');
                    extRef.dataset.gettaskres = "";
                    extRef.dataset.isSuccess = false;

                    setButtonClass(clsx("Clear"));
                    setButtonClass(clsx("noClass"));

                    clearInputValue(document.getElementById('impianto'), '');
                    clearInputValue(document.getElementById('codice_impresa_name'), '');
                    clearInputValue(document.getElementById('tipo_task'), '');
                    clearInputValue(document.getElementById('wr_prodotti'), '');
                    clearInputValue(document.getElementById('cod_proj'), '');
                    clearInputValue(document.getElementById('client_type'), '');
                    clearInputValue(document.getElementById('resource_id'), '');
                    clearInputValue(document.getElementById('equivalenza_prod_applicabile'), '');

                    return translate('tim.devices.get_task_mandatori');
                }
            }
        }

        return undefined;
    }

    const validateWR = [validateWorkrequestid, required()]

    const validateNote = (value, allValues) => {
        if (value) {
            let format = /[^a-zA-Z0-9 ]/g;
            if (format.test(value)) return translate('tim.devices.invalid_note');
        }
        return undefined;
    }

    const ShowReverse = () => {

        if (permissions === 'magazziniere') {
            if (IsOtherImpresa(formValues.cod_terr_sap) && formValues.status && formValues.status.codice !== '1') {
                return false;
            }
            else if (['2', '7'].includes(new_status)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false
        }
    }

    const Workrequestid = () => {
        const record = useRecordContext();
        if (permissions === 'magazziniere') {
            if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
                return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" sx={{ display: 'none' }} />
            }
            else if (record.status && record.anomalia && record.status.codice === '0' && ['0', '16'].includes(record.anomalia.codice)) {
                return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" sx={{ display: 'none' }} />
            }
            else if (['2', '7'].includes(new_status)) {
                return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" validate={validateWR} />
            }
            else if (['0', '1'].includes(new_status)) {
                return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" sx={{ display: 'none' }} />
            }
            else if (!['0', '2', '7'].includes(new_status)) {
                return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" sx={{ display: 'none' }} />
            }
        }
        return <NumberInput source="workrequestid" id="workrequestid" label="WorkrequestId" sx={{ display: 'none' }} />
    }

    const ShowGetTaskButton = () => {
        const record = useRecordContext();
        if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
            return null
        }
        else if (record.status && record.anomalia && record.status.codice === '0' && ['0', '16'].includes(record.anomalia.codice)) {
            return null
        }
        else if (permissions === 'magazziniere' && ['0'].includes(new_status)) {
            return null
        }
        else if (permissions === 'magazziniere' && ['2', '7'].includes(new_status)) {
            return <GetTaskButton buttonClass={buttonClass} />
        }
        return null;
    }

    const NumConsegna = () => {
        const record = useRecordContext();

        if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
            return <TextInput source="num_consegna" sx={{ display: 'none' }} />
        }
        return <TextInput source="num_consegna" />
    }

    const CanEditFornitore = () => {
        const record = useRecordContext();

        if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
            return false;
        }
        return true;
    }

    const CodStatoUso = () => {
        const record = useRecordContext();

        if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
            return <SelectInput source="cod_stato_uso.codice" choices={CodStatoUsoChoices} label="Partita del materiale" disabled />
        }
        return <SelectInput source="cod_stato_uso.codice" choices={CodStatoUsoChoices} label="Partita del materiale" validate={required('tim.devices.mandatory')} />
    }

    const Causale = () => {
        const record = useRecordContext();

        if (permissions === "magazziniere") {
            if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
                return null
            }
            if (record.status && ["1", "6"].includes(record.status.codice) && ["1", "6"].includes(new_status)) {
                return <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} sx={{ display: 'none' }} />
            }
            else if (record.status && ["2", "7"].includes(record.status.codice) && new_status === "0") {
                return <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} sx={{ display: 'none' }} />
            }
            else if (record.status && ["2", "7"].includes(record.status.codice) && new_status === "3") {
                return <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} sx={{ display: 'none' }} />
            }
            else if (record.status && record.status.codice === "0" && new_status === "9") {
                return <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices}  sx={{ display: 'none' }}/>
            }
            else {
                return <SelectInput source="causale.codice" label="Causale" choices={CausaliChoices} sx={{ display: 'none' }} validate={required('tim.devices.mandatory')} />
            }
        }
        else {
            return null;
        }
    }

    const ShowCausaleAddebito = () => {
        const record = useRecordContext();
        if (!record) return false;

        if (permissions === "approvatore" && record.status && record.status.codice === '3' && new_status === '4') {
            return true;
        }
        else {
            return false;
        }
    }

    const Anomalia = () => {
        const record = useRecordContext();
        if (!record) return false;

        if (permissions === "magazziniere" && new_status === '0') {
            if (record.status && ['1', '6'].includes(record.status.codice)) {
                return <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie_Magazziniere_Attr} validate={required('tim.devices.mandatory')} onChange={onChange} />
            }
            else if (record.status && ['2', '7'].includes(record.status.codice)) {
                return <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie_Magazziniere} validate={required('tim.devices.mandatory')} onChange={onChange} />
            }
            else {
                return null;
            }
        }
        else if (permissions === "approvatore" && new_status === '0') {
            return <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie_Approvatore_To_DaEsaminare} validate={required('tim.devices.mandatory')} onChange={onChange} />
        }
        else if (permissions === "approvatore" && new_status === '5') {
            return <SelectInput source="anomalia.codice" label="Anomalia" choices={Anomalie_Approvatore_To_Scaricato} validate={required('tim.devices.mandatory')} onChange={onChange} />
        }
        else {
            return null;
        }
    }

    const Status = () => {
        const record = useRecordContext();
        if (!record) return false;

        //Needed because on validateDevice() we are unable to read recorrd = useRecordContext() to get the initial value of workrequestid
        setOriginalWR(record.workrequestid);

        if (permissions === "magazziniere") {
            let impresa_cod_terr_sap = localStorage.getItem('impresa_cod_terr_sap');
            impresa_cod_terr_sap = (!impresa_cod_terr_sap || impresa_cod_terr_sap === "") ? [] : JSON.parse(impresa_cod_terr_sap);
            let cod_terr_sap = localStorage.getItem('cod_terr_sap');
            cod_terr_sap = (!cod_terr_sap || cod_terr_sap === "") ? [] : JSON.parse(cod_terr_sap);
            //If it's a device for his impresa but he shouldn't see it, only allow an update to Associato
            if (!impresa_cod_terr_sap.includes(record.cod_terr_sap) ||
                (impresa_cod_terr_sap.includes(record.cod_terr_sap) && !cod_terr_sap.includes(record.cod_terr_sap))) {
                if (record.codice_magazzino && record.codice_magazzino.startsWith("IB")) {
                    if (record.status && record.status.codice === '6') {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses_2_MagazziniereIB_OtherCodTerrSAP} onChange={onChange} validate={required()} />
                    }
                    else {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses} sx={{ display: 'none' }} validate={required()} />
                    }
                }
                else {
                    if (record.status && record.status.codice === '1') {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses_2_Magazziniere_OtherCodTerrSAP} onChange={onChange} validate={required()} />
                    }
                    else {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses} sx={{ display: 'none' }} validate={required()} />
                    }
                }
            }
            else if (record.codice_magazzino && record.codice_magazzino.startsWith("IB")) {
                if (record.status && record.status.codice === '6') {
                    return <SelectInput source="status.codice" label='Stato' choices={Statuses_2_MagazziniereIB} onChange={onChange} validate={required()} />
                }
                else if (record.status && record.status.codice === '0') {
                    if (record.anomalia && record.anomalia.codice === '0') {
                        return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
                    }
                    else {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses_0_MagazziniereIB} onChange={onChange} validate={required()} />
                    }
                }
                else {
                    return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
                }
            }
            else {
                if (record.status && record.status.codice === '2') {
                    return <SelectInput source="status.codice" label='Stato' choices={Statuses_2_Magazziniere} onChange={onChange} validate={required()} />
                }
                else if (record.status && record.status.codice === '1') {
                    return <SelectInput source="status.codice" label='Stato' choices={Statuses_1_Magazziniere} onChange={onChange} validate={required()} />
                }
                else if (record.status && record.status.codice === '0') {
                    if (record.anomalia && record.anomalia.codice === '0') {
                        return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
                    }
                    else if (record.anomalia && record.anomalia.codice === '8') {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses_0_Magazziniere_Guasto} onChange={onChange} validate={required()} />
                    }
                    else {
                        return <SelectInput source="status.codice" label='Stato' choices={Statuses_0_Magazziniere} onChange={onChange} validate={required()} />
                    }
                }
                else {
                    return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
                }
            }
        }
        else if (permissions === "approvatore") {
            if (record.status && record.status.codice === '3') {
                return <SelectInput source="status.codice" label='Stato' choices={Statuses_3_Approvatore} onChange={onChange} validate={required()} />
            }
            else if (record.status && record.status.codice === '4') {
                return <SelectInput source="status.codice" label="Stato" choices={Statuses_4_Approvatore} onChange={onChange} validate={required()} />
            }
            else if (record.status && record.status.codice === '0') {
                return <SelectInput source="status.codice" label="Stato" choices={Statuses_0_Approvatore} onChange={onChange} validate={required()} />
            }
            else {
                return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
            }
        }
        else {
            return <Labeled label="Stato"><TextField source="status.descrizione" style={{borderBottom: '1px solid rgba(0, 0, 0, 0.42)', width: '10rem', color: 'grey' }} /></Labeled>
        }
    }

    function clearInputValue(element, value) {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
        element.dispatchEvent(new Event('input', { bubbles: true }));
    };

    function IsOtherImpresa(device_cod_terr_sap) {
        let impresa_cod_terr_sap = localStorage.getItem('impresa_cod_terr_sap');
        impresa_cod_terr_sap = (!impresa_cod_terr_sap || impresa_cod_terr_sap === "") ? [] : JSON.parse(impresa_cod_terr_sap);

        if (!impresa_cod_terr_sap.includes(device_cod_terr_sap)) {
            return true
        }
        return false
    }

    const CodTerrSapList = () => {
        const record = useRecordContext();
        if (!record) return false;

        if (IsOtherImpresa(record.cod_terr_sap) && record.status && record.status.codice !== '1') {
            return <TextInput source="cod_terr_sap" sx={{ display: 'none' }} />
        }
        var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
        var res = [];
        if (user_cod_terr_sap) {
            var x = JSON.parse(user_cod_terr_sap);
            x.forEach(function (c) {
                res.push({ id: c, name: c });
            })
        }
        return <SelectInput source="cod_terr_sap" choices={res} validate={required('tim.devices.mandatory')} />;
    }

    const Aside = () => {
        const record = useRecordContext();
        if (record) {
            return (
                <Box sx={{ width: '500px', ml: '1em' }}>
                    <Card sx={{ padding: '1em' }}>
                        <Typography variant="h6" sx={{ marginBottom: '1em' }}>Dati di dettaglio</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.serial_number_tim')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.serial_number_tim}
                                </Typography>
                            </Grid>

                            {(!canEdit() || !CanEditFornitore) && (
                                <><Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.serial_number_forn')}
                                    </Typography>
                                </Grid><Grid item xs={6}>
                                        <Typography variant="body2"  >
                                            {record.serial_number_forn}
                                        </Typography>
                                    </Grid></>)}

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.mac_address')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.mac_address}
                                </Typography>
                            </ Grid>

                            {!canEdit() && (<><Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.cod_terr_sap')}
                                </Typography>
                            </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.cod_terr_sap}
                                    </Typography>
                                </Grid></>)}

                            {!canEdit() && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.num_consegna')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.num_consegna}
                                    </Typography>
                                </Grid>
                            </>)}

                            {!canEdit() && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.cod_stato_uso.codice')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.cod_stato_uso && (record.cod_stato_uso.descrizione)}
                                    </Typography>
                                </Grid>
                            </>)}

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.impianto_regman')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.impianto_regman}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.status_regman.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.status_regman ? record.status_regman.descrizione : ''}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.serial_number_cpe')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.serial_number_cpe}
                                </Typography>
                            </ Grid>

                            {!ShowCausaleAddebito() && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.causale_addebito.codice')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.causale_addebito && (record.causale_addebito.codice)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.note_addebito')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.note_addebito}
                                    </Typography>
                                </Grid>
                            </>)}

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.workrequestid')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.workrequestid}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.impianto')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {formValues?.impianto !== undefined ? formValues.impianto : record.impianto}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.codice_impresa_name')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" >
                                    {formValues?.codice_impresa_name !== undefined ? formValues.codice_impresa_name : record.codice_impresa_name}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.causale.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" >
                                    {formValues && formValues['causale.codice'] !== undefined ? CausaliChoices.find(c => c.id == formValues['causale.codice'])?.name : (record.causale ? record.causale.descrizione : undefined)}
                                </Typography>
                            </ Grid>

                            {!ShowReverse() && (<>
                                <Grid item xs={6}>
                                    <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                        {translate('resources.devices.fields.reverse.descrizione')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2"  >
                                        {record.reverse && (record.reverse.descrizione)}
                                    </Typography>
                                </Grid>
                            </>)}

                            {record.anomalia && (<><Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.anomalia.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {record.anomalia.descrizione}
                                </Typography>
                            </ Grid></>)}
                        </Grid>
                    </Card>
                </Box>
            );
        }
        else {
            return (
                <div style={{ width: 200, margin: '1em' }}>
                    <Typography variant="h6">Device details</Typography>
                </div>
            );
        }
    };

    const canEdit = () => {
        return (permissions === 'magazziniere' && new_status === '0' && new_anomalia && new_anomalia !== '6');
    }

    const canEditNote = () => {
        return (permissions === 'approvatore' && ['0', '4'].includes(new_status));
    }

    const handleValueChange = e => {
        const { name, value } = e.target;
        setFormValues(formValues => ({
            ...formValues,
            ...{ [name]: value }
        }));
    }

    return (
        <Edit title={<DeviceTitle />} aside={<Aside />} >
            <FormProvider {...methods}>
                <SimpleForm toolbar={<DeviceToolbar />}>
                    <Status />
                    <Anomalia />
                    {(canEdit() && CanEditFornitore()) && <TextInput source="serial_number_forn" />}
                    <Box sx={{ display: 'inline-flex' }}>
                        <Workrequestid />
                        <ShowGetTaskButton />
                    </Box>

                    {canEdit() && <CodTerrSapList />}
                    {canEdit() && <NumConsegna />}
                    {canEdit() && <CodStatoUso />}
                    {ShowReverse() && <SelectInput source="reverse.codice" label="Reverse" choices={ReverseChoices} />}
                    {permissions === 'magazziniere' && <TextInput source="causale.codice" sx={{ display: 'none' }} onChange={handleValueChange} />}
                    {permissions !== 'magazziniere' && <Causale />}
                    {canEditNote() && <TextInput source="note" rowsMax={8} multiline maxWidth="500" validate={validateNote} />}
                    {ShowCausaleAddebito() && <div><SelectInput source="causale_addebito.codice" label="Causale Addebitato" choices={Causale_Addebito} /><br /><TextInput source="note_addebito" rowsMax={8} multiline maxWidth="500" /></div>}

                    {/* Hidden fields */}
                    <TextInput source="externalrefid" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="impianto" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="codice_impresa_name" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="tipo_nmu" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="codice_riscontro" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="post_delivery" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="equivalenza_prod_applicabile" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="blinda_scarico_mat" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="proprieta_materiale" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="one_step" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="desc_tp_diagnosi" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="aclrr" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="tipo_task" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="wr_prodotti" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="cod_proj" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="client_type" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="resource_id" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="data_completamento_wr" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="check_NMU" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="descrizione_impresa" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="lista_NMU" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="codice_isp" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="flag_olo" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="tsys" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="area" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="progetto_con_scarico" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="tipo_nmu" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="codice_riscontro" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="post_delivery" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="equivalenza_prod_applicabile" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="blinda_scarico_mat" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="proprieta_materiale" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="one_step" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="desc_tp_diagnosi" sx={{ display: 'none' }} onChange={handleValueChange} />
                    <TextInput source="aclrr" sx={{ display: 'none' }} onChange={handleValueChange} />

                </SimpleForm>
            </FormProvider>
        </Edit>
    );
}

export default DeviceEdit;